import { FilingDetailEntityInterface } from './types';

export const formatDebSec = (debSec: FilingDetailEntityInterface) =>
  [debSec.address, debSec.city, debSec.state, debSec.zipCode]
    .filter(Boolean)
    .map((d) => d.trim())
    .join(', ');
